var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateQueryParamsStr } from "../../utils/apiUtils";
const GET_SET_SECTIONS = 'api/section';
const GET_SET_SECTIONS_WASHDAY_APP = 'api/v2/washdayapp/sections';
export const getList = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            let queryParams = '';
            if (params === null || params === void 0 ? void 0 : params.hasOwnProperty('storeId')) {
                queryParams += `store=${params === null || params === void 0 ? void 0 : params.storeId}`;
            }
            if (params === null || params === void 0 ? void 0 : params.hasOwnProperty('isActive')) {
                queryParams += `&isActive=${params === null || params === void 0 ? void 0 : params.isActive}`;
            }
            else {
                queryParams += `&isActive=true`;
            }
            if (params === null || params === void 0 ? void 0 : params.hasOwnProperty('products')) {
                queryParams += `&products=${params === null || params === void 0 ? void 0 : params.products}`;
            }
            return yield this.axiosInstance.get(`${GET_SET_SECTIONS}?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getStoreStaff:', error);
            throw error;
        }
    });
};
export const getById = function (id, options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = (options === null || options === void 0 ? void 0 : options.expand)
                ? `?expand=${encodeURIComponent(options.expand)}`
                : "";
            return yield this.axiosInstance.get(`${GET_SET_SECTIONS}/${id}${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getSectionById:', error);
            throw error;
        }
    });
};
export const getSubcategories = function (sectionId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_SET_SECTIONS}/${sectionId}/subcategories`, config);
        }
        catch (error) {
            console.error('Error fetching getSubcategories:', error);
            throw error;
        }
    });
};
export const getSectionsByStoreCustomersApp = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'storeId',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_SECTIONS_WASHDAY_APP}?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getSectionsByStoreCustomersApp:', error);
            throw error;
        }
    });
};
